export enum CONSENT_KEYS {
  RECURRING = 'ONSTAR_RECURRING_CONSENT',
  DATA = 'ATT_DATA_CONSENT',
  VELOCITY = 'VELOCITY_CONSENT',
  FLEXCAM = 'FLEXCAM_CONSENT',
  INFINITYTUNE = 'INFINITY_TUNE',
  THEMES = 'THEMES_CONSENT',
  CONNECTED_CAMARA = 'CONNECTED_CAMARA_CONSENT',
  SUPERCRUISE = 'SUPERCRUISE_CONSENT',
  EXISTING_PLAN = 'EXISTING_PLAN_CONSENT',
  USER_TERMS_PRIVACY = 'USER_TERMS_PRIVACY',
  ONSTAR_DISCLOSURE = 'ONSTAR_DISCLOSURE'
}

export enum COPY_KEYS {
  RETURN_HEADER = 'checkout.return.header',
  SAVE = 'checkout.save',
  CANCEL = 'checkout.cancel',
  SELECT_PAYMENT_METHOD = 'payment.select.method',
  LOAD_ERROR = 'checkout.error.load',
  ERROR_CALL = 'checkout.error.call',
  TRY_AGAIN = 'checkout.try.again',
  ERROR_PROCESSING = 'checkout.error.processing',
  CHECKOUT_CALL = 'checkout.call',
  ERROR_GENERIC = 'checkout.error.generic',
  ACCEPT_TERMS_CONDITIONS = 'checkout.accept.terms.conditions',
  PAYMENT_EXPIRING_UPDATE = 'payment.expiring.update',
  PAYMENT_HEADER = 'payment.header',
  PAYMENT_UPDATED = 'payment.update.saved',
  PAYMENT_EXPIRING = 'payment.expiring'
}

export enum PLACE_ORDER_KEYS {
  CREDIT_CARD = 'CREDITCARD',
  ACH = 'ACH',
  PAYPAL = 'PAYPAL'
}
 
export const CHECKOUT_KEYS = {
  CONSENTS: CONSENT_KEYS,
  COPY: COPY_KEYS,
  PLACE_ORDER: PLACE_ORDER_KEYS
} as const;
